// #ux-redesign-start: <Toaster> — provider Radix Toast + viewport
// Se monta una sola vez al nivel del App. Escucha el store imperativo
// expuesto en `toast.js` y renderiza cada notificacion como <Toast.Root>.
// Tokens DS para color/sombra/radius, animacion swipe-to-dismiss.
//
// PORTABILIDAD: idéntico para Web-Patients.
// ─────────────────────────────────────────────────────────────────────────────
import React, { useEffect, useState, useCallback } from 'react';
import * as RT from '@radix-ui/react-toast';
import { subscribeToToasts } from './toast';

const ICONS = {
  success: '✓',
  error: '✕',
  warning: '!',
  info: 'i',
  default: '',
};

const Toaster = ({ duration = 4500, swipeDirection = 'right' }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    return subscribeToToasts((event) => {
      if (event.kind === 'add') {
        setItems((prev) => [...prev, event.toast]);
      } else if (event.kind === 'dismiss') {
        setItems((prev) => prev.filter((p) => p.id !== event.id));
      } else if (event.kind === 'clear') {
        setItems([]);
      }
    });
  }, []);

  const handleOpenChange = useCallback((id, open) => {
    if (!open) {
      setItems((prev) => prev.filter((p) => p.id !== id));
    }
  }, []);

  return (
    <RT.Provider duration={duration} swipeDirection={swipeDirection}>
      {items.map((t) => (
        <RT.Root
          key={t.id}
          open
          duration={t.duration ?? duration}
          onOpenChange={(open) => handleOpenChange(t.id, open)}
          className={`ds-toast ds-toast--${t.type || 'default'}`}
        >
          <span className="ds-toast__icon" aria-hidden="true">
            {ICONS[t.type] || ICONS.default}
          </span>
          <div className="ds-toast__body">
            {t.title && <RT.Title className="ds-toast__title">{t.title}</RT.Title>}
            <RT.Description className="ds-toast__message">
              {typeof t.message === 'string' ? t.message : t.message}
            </RT.Description>
          </div>
          <RT.Close className="ds-toast__close" aria-label="Cerrar">
            ×
          </RT.Close>
        </RT.Root>
      ))}
      <RT.Viewport className="ds-toast-viewport" />
    </RT.Provider>
  );
};

export default Toaster;
// #ux-redesign-end
